// Subtle synthesized metallic chime for the hero carousel.
// Uses the Web Audio API so no audio asset is required.
let ctx = null;
let muted = false;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

export const setChimeMuted = (v) => { muted = v; };
export const isChimeMuted = () => muted;

export const playMetalChime = () => {
  if (muted) return;
  const ac = getCtx();
  if (!ac) return;

  const now = ac.currentTime;
  const master = ac.createGain();
  master.gain.value = 0.0;
  master.connect(ac.destination);

  // Bell-like inharmonic partials for a shimmering metallic timbre.
  const partials = [
    { f: 1046, g: 1.0 },
    { f: 1567, g: 0.55 },
    { f: 2093, g: 0.35 },
    { f: 2794, g: 0.18 },
  ];

  partials.forEach(({ f, g }) => {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(f, now);
    gain.gain.value = g;
    osc.connect(gain).connect(master);
    osc.start(now);
    osc.stop(now + 1.2);
  });

  // Gentle attack, long decay -> soft chime, kept low in volume.
  const peak = 0.06;
  master.gain.setValueAtTime(0.0, now);
  master.gain.linearRampToValueAtTime(peak, now + 0.01);
  master.gain.exponentialRampToValueAtTime(0.0001, now + 1.1);
};
